<template>
  <div>
    <spot-detail-modal :isDetailShowed="$store.getters['modal/getModal'].includes(constant.modal.detail)" :class="{active: $store.getters['modal/getModal'].includes(constant.modal.detail)}"></spot-detail-modal>
    <login-modal :class="{active: $store.getters['modal/getModal'].includes(constant.modal.login)}"></login-modal>
    <photo-confirm-modal :class="{active: $store.getters['modal/getModal'].includes(constant.modal.photoConfirm)}"></photo-confirm-modal>
    <util-modal :class="{active: $store.getters['modal/getModal'].includes(constant.modal.util)}"></util-modal>
  </div>
</template>

<script>
import UtilModal from './UtilModal'
import SpotDetailModal from './SpotDetailModal'
import LoginModal from './LoginModal'
import PhotoConfirmModal from './PhotoConfirmModal'
import constant from '../../../utils/vue/Constant'
import store from '../../../vuex/index'

export default {
  name: 'modal',
  components: {
    UtilModal,
    SpotDetailModal,
    LoginModal,
    PhotoConfirmModal
  },
  data () {
    return {
      constant: constant,
      localeCode: store.getters['locale/getLocaleCode'],
      formErrors: {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/vue/Modal.vue